// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-black {
  color: #212121;
}

.text-white {
  color: #FAFAFA;
}

.color-primary {
  color: #0d67bc;
}

.color-primary-dark {
  color: #172b3d;
}

.color-primary-light {
  color: #4a8bc8;
}

.color-secondary {
  color: #e3f2fc;
}

.color-secondary-dark {
  color: #b1bfc9;
}

.color-secondary-light {
  color: #ffffff;
}

.color-error {
  color: #f44336;
}

.color-warning {
  color: #f49536;
}

.color-accent {
  color: #e3f2fc;
}

.color-success {
  color: #2CBD04;
}

.color-hyperlink {
  color: #0000FF;
}

.background-primary {
  background-color: #0d67bc;
}

.well-color {
  background-color: #bbdff9;
}

.color-carshield-hyperlink {
  color: #1c3344;
}

.line-item {
  padding-left: 0.5em;
}

.cdk-drag-preview {
  border: none;
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  padding: 1em;
}

.cdk-drag-placeholder {
  opacity: 0;
}

.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}`, "",{"version":3,"sources":["webpack://./style/brand/colors.scss","webpack://./src/app/claims-app/estimates/estimate-list/estimate-list.component.scss"],"names":[],"mappings":"AAqBA;EACI,cAPS;ACbb;;ADuBA;EACI,cAVS;ACVb;;ADuBA;EACI,cAzBU;ACKd;;ADuBA;EACI,cA3Be;ACOnB;;ADuBA;EACI,cAhCgB;ACYpB;;ADuBA;EACI,cAlCY;ACchB;;ADuBA;EACI,cApCiB;ACgBrB;;ADuBA;EACI,cAzCkB;ACqBtB;;ADuBA;EACI,cAnDS;AC+Bb;;ADuBA;EACI,cAxDW;ACoCf;;ADuBA;EACI,cAnDS;AC+Bb;;ADuBA;EACI,cAjEW;AC6Cf;;ADuBA;EACI,cAxDa;ACoCjB;;ADuBA;EACI,yBArEU;ACiDd;;ADuBA;EACI,yBAjES;AC6Cb;;ADuBA;EACI,cAhEa;AC4CjB;;AA5DA;EACI,mBAAA;AA+DJ;;AA5DA;EACE,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,qHAAA;EAGA,gBAAA;EACA,YAAA;AA6DF;;AA1DA;EACE,UAAA;AA6DF;;AA1DA;EACE,sDAAA;AA6DF","sourcesContent":["$colorinfo: #424242;\r\n$colorSuccess: #2CBD04;\r\n$colorWarning: #f49536;\r\n$colorError: #f44336;\r\n$colorMuted: #000000;\r\n$Web-primary: #0d67bc;\r\n$Web-primary-light: #4a8bc8;\r\n$Web-primary-dark: #172b3d;\r\n$Web-secondary: #e3f2fc;\r\n$Web-secondary-light: #ffffff;\r\n$Web-secondary-dark: #b1bfc9;\r\n$Web-accent: #e3f2fc;\r\n$danger-dark: #b22222;\r\n$well-color: #bbdff9;\r\n$hyperlink-blue: #0000FF;\r\n$Text-black: #212121;\r\n$Text-white: #FAFAFA;\r\n$Light-gray: #e8e8e8;\r\n$Carshield-dark: #1c3344;\r\n$aas-warn: #c12c2d;  //Copied from Themes.scss\r\n\r\n.text-black {\r\n    color: $Text-black;\r\n}\r\n\r\n.text-white {\r\n    color: $Text-white;\r\n}\r\n\r\n.color-primary {\r\n    color: $Web-primary;\r\n}\r\n\r\n.color-primary-dark {\r\n    color: $Web-primary-dark\r\n}\r\n\r\n.color-primary-light {\r\n    color: $Web-primary-light;\r\n}\r\n\r\n.color-secondary {\r\n    color: $Web-secondary;\r\n}\r\n\r\n.color-secondary-dark {\r\n    color: $Web-secondary-dark;\r\n}\r\n\r\n.color-secondary-light {\r\n    color: $Web-secondary-light;\r\n}\r\n\r\n.color-error {\r\n    color: $colorError;\r\n}\r\n\r\n.color-warning {\r\n    color: $colorWarning;\r\n}\r\n\r\n.color-accent {\r\n    color: $Web-accent;\r\n}\r\n\r\n.color-success {\r\n    color: $colorSuccess;\r\n}\r\n\r\n.color-hyperlink {\r\n    color: $hyperlink-blue;\r\n}\r\n\r\n.background-primary {\r\n    background-color: $Web-primary;\r\n}\r\n\r\n.well-color {\r\n    background-color: $well-color;\r\n}\r\n\r\n.color-carshield-hyperlink {\r\n    color: $Carshield-dark;\r\n}","@import '/style/brand/colors.scss';\r\n\r\n.line-item {\r\n    padding-left: 0.5em;\r\n}\r\n\r\n.cdk-drag-preview {\r\n  border: none;\r\n  box-sizing: border-box;\r\n  border-radius: 4px;\r\n  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),\r\n              0 8px 10px 1px rgba(0, 0, 0, 0.14),\r\n              0 3px 14px 2px rgba(0, 0, 0, 0.12);\r\n  overflow: hidden;\r\n  padding: 1em;\r\n}\r\n\r\n.cdk-drag-placeholder {\r\n  opacity: 0;\r\n}\r\n\r\n.cdk-drag-animating {\r\n  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
